import { ConstantFormat, DateFns } from "../../../../../../../utils/DateFns";

import type { Order } from "../../../../../../../services";

const cellProcessing = (
	item?: Order.Model["executingStages"],
	dateFns?: DateFns,
) => {
	const timestamp = item?.arrived?.timestamp;
	const content =
		timestamp && dateFns
			? dateFns.formatTime(timestamp, {
					formatTime: ConstantFormat.HMS_UK,
					isTimezone: true,
			  })
			: "";
	return { content };
};

export default cellProcessing;
